import React from "react"


export const RenderErrorMessage = (props) => {
  const { errorMsg } = props
  return (
    <span className="text-danger f-14 d-inline-block  mt-1 line-height-error">{errorMsg}</span>
  )
}